import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import { Navigate } from 'react-router-dom';
import { PDFViewer } from '@react-pdf/renderer';
import ReactPDF, { Page, Text, View, Document, StyleSheet, Image, Font, PDFDownloadLink, Svg } from '@react-pdf/renderer';
import axios from "axios";
import "./styles.css";
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  InputLabel,
  FormControl,
  Select,
  TextField
} from '@mui/material';
// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
import ClanProfil from '../pages/ClanProfil';
import BuildingReport from './BuildingReport';
import HuntersClanoviSkupstine from './HuntersClanoviSkupstine';
import BuildingCreate from '../pages/BuildingCRUDPages/create';
import HuntersIzborForAwardAll from './HuntersIzborForAwardAll';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
// mock

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'odlikovanje', label: 'Odlikovanje', alignRight: false },
  { id: 'imeiprezime', label: 'Ime i prezime', alignRight: false },
  { id: 'hunter.huntingclubId', label: 'Lovačko društvo', alignRight: false },
  { id: 'datum', label: 'Datum', alignRight: false },
  { id: 'opis', label: 'Opis', alignRight: false },
  { id: 'napomena', label: 'Napomena', alignRight: false },
  { id: 'delete', label: 'Delete', alignRight: false }
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query, field) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  
  if (query) {
	  
	if (field === 'imeiprezime')
    return filter(array, (_user) => (_user.hunter.ime.toLowerCase() + ' ' + _user.hunter.prezime.toLowerCase()).indexOf(query.toLowerCase()) !== -1);

	if (field === 'hunter.huntingclubId')
    return filter(array, (_user) => _user.hunter.huntingclub.naziv.toLowerCase().indexOf(query.toLowerCase()) !== -1);

	if (field === 'odlikovanje')
    return filter(array, (_user) => _user.awardtype.naziv.toLowerCase().indexOf(query.toLowerCase()) !== -1);

	if (field === 'datum')
    return filter(array, (_user) => _user.datum.toLowerCase().indexOf(query.toLowerCase()) !== -1);

	if (field === 'opis')
    return filter(array, (_user) => _user.opis.toLowerCase().indexOf(query.toLowerCase()) !== -1);

	if (field === 'napomena')
    return filter(array, (_user) => _user.napomena.toLowerCase().indexOf(query.toLowerCase()) !== -1);

  }
  
  return stabilizedThis.map((el) => el[0]);
}

export default function AwardsReportAll() {
	
  const [buildings, setBuildings] = useState([]);
 
  const [buildingsdataloaded, setBuildingsDataLoaded] = useState(false);
  
  const [building, setBuilding] = useState('');
  
  const [showbuildingreport, setShowBuildingReport] = useState(false);
  
  const [huntingclub, setHuntingClub] = useState('');
	
  const [showbuildingcreate, setShowBuildingCreate] = useState(false);
  
  const [awardId, setAwardId] = useState('');
  
	
  const [meetingid, setMeetingId] = useState('');
	
  const [huntingclubid, setHuntingClubId] = useState('');
	
  const [loading, setLoading] = useState(false);
	
  const [showreport, setShowReport] = useState(false);

  const [id, setId] = useState('');
	
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');
  
  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('id');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);
  
  const { user: currentUser } = useSelector((state) => state.auth);
  
  const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;
   
  useEffect(() => {
  if (!buildingsdataloaded) {
    getAllBuildings();
	//console.log(currentUser.roles[0]);
    const role = currentUser.roles[0];
    const rolenumber = role.slice(10);
    //console.log(rolenumber);
	getHuntingClub(rolenumber);
  }  
  }); 
  
  const handleClose = () => {
    setOpen(false);
  };

  const handleNo = () => {
    setOpen(false);
  };
  
  const handleYes = () => {
	console.log("Deleting:" + awardId);
    axios.delete(SERVER_URL + "/awards/" + awardId, 
	{}
	).then(() => {
		getAllBuildings();
	});
		
    setOpen(false);
  };
  
  const getAllBuildings = async () => {
      try {
        const response = await axios.get(SERVER_URL + "/awards");
        setBuildings(response.data);
		setBuildingsDataLoaded(true);
		console.log(response.data);
      } catch (err) {
        console.log("error");
      }
  };
    
  const getHuntingClub = async (huntingclubid) => {
      try {
		console.log(huntingclubid);  
        const response = await axios.get(SERVER_URL + "/huntingclubs/" + huntingclubid);
        setHuntingClub(response.data);
		console.log(response.data);
      } catch (err) {
        console.log("error");
      }
  };
  
  const getBuilding = async (buildingid) => {
      try {
        const response = await axios.get(SERVER_URL + "/buildings/" + buildingid);
        setBuilding(response.data);
		setShowBuildingReport(!showbuildingreport);
		console.log(response.data);
      } catch (err) {
        console.log("error");
      }
  };
  
  if (!currentUser) {
    return <Navigate to="/login" />;
  }
  
  const setData = (data) => {
  console.log(data);
  
  const { id, maticnibrojlovca, ime, prezime, adresa, telefon, lovackodrustvo, datumpolaganja, vrstaclanstva, photo, lovackilist } = data;
  
  console.log(id);
  console.log(adresa);
  
  localStorage.setItem('id', id);
  localStorage.setItem('maticnibrojlovca', maticnibrojlovca);
  localStorage.setItem('ime', ime);  
  localStorage.setItem('prezime', prezime);
  localStorage.setItem('adresa', adresa);
  localStorage.setItem('telefon', telefon);
  localStorage.setItem('lovackodrustvo', lovackodrustvo);
  localStorage.setItem('datumpolaganja', datumpolaganja);
  localStorage.setItem('vrstaclanstva', vrstaclanstva);
  localStorage.setItem('photo', photo);
  localStorage.setItem('lovackilist', lovackilist);
  
  }
  
  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
	console.log(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = buildings.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClickDelete = (event, id) => {
	console.log(id);
	setAwardId(id);
	setOpen(true);
  };
  
  const DeleteAward = (id) => {
    console.log(id);
    axios.delete("http://89.46.196.228:3000/api/awards/" + id, 
	{}
	).then(() => {
		getAllBuildings();
	});
		
		
    setOpen(false);
  };
  
  const handleClickSelect = (event, id) => {
	  
	// console.log(id);
	
	// setMeetingId(id);
  };
  
  const handleRefresh = (event, id) => {  
	// setShowBuildingCreate(!showbuildingcreate);
	getAllBuildings();
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - buildings.length) : 0;

  const filteredTrophies = applySortFilter(buildings, getComparator(order, orderBy), filterName, orderBy);

  const isNotFound = !filteredTrophies.length && !!filterName;
  
  var today = new Date();

  const datum ='Datum: ' +  today.getDate()  + '.' + (today.getMonth() + 1) + '.' + today.getFullYear() + '. god.';

Font.register({
  family: "Roboto",
  src:
    "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf"
});

const styles = StyleSheet.create({
  page: {
    fontFamily: "Roboto"
  },
  body: {
    paddingTop: 50,
    paddingBottom: 65,
    paddingHorizontal: 30,
	fontFamily: "Roboto", 
	fontSize: 10,
  },
  title: {
    fontSize: 24,
    textAlign: 'center',
    fontFamily: 'Roboto'
  },
  author: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 40,
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    fontFamily: 'Roboto'
  },
  text: {
    margin: 5,
    fontSize: 12,
    textAlign: 'justify',
    fontFamily: 'Roboto',
	paddingHorizontal: 20,
  },
  textmedium: {
    margin: 3,
    fontSize: 12,
    textAlign: 'justify',
    fontFamily: 'Roboto',
	paddingHorizontal: 20,
  },
  textmediumlarge: {
    margin: 12,
    fontSize: 20,
    textAlign: 'justify',
    fontFamily: 'Roboto'
  },
  textbig: {
    margin: 12,
    fontSize: 28,
    textAlign: 'justify',
    fontFamily: 'Roboto'
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: 'center',
    color: 'grey',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
  officer: {
	paddingTop: 70,
    fontSize: 12,
	margin: 0,
    fontSize: 12,
    fontFamily: 'Roboto',
	left: 150,
  },
  officertext: {
    margin: 0,
    fontSize: 12,
    textAlign: 'center',
    fontFamily: 'Roboto',
  },
  mp: {
    position: 'absolute',
    fontSize: 12,
    bottom: 100,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey'
  },
  table: { 
    display: "table", 
    width: "auto", 
    borderStyle: "solid",  
    borderRightWidth: 0, 
	borderLefttWidth: 0, 
    borderTopWidth: 0,
	borderBottomWidth: 0,
  }, 
  tableRow: { 
    margin: "0", 
    flexDirection: "row",
	 borderWidth: 0,
  }, 
  tableCol: { 
    width: "20%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  }, 
  tableColLong: { 
    width: "30%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableColShort: { 
    width: "15%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableColVeryShort: { 
    width: "5%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableCell: { 
    margin: "auto", 
    marginTop: 5, 
    fontSize: 10 
  },
});

  const BuildingsReportAll = () => (
	<Document>
    <Page size="A4" orientation="portrait" scale={0.5} style={styles.body} wrap>
		<Text style={styles.textmedium}>{huntingclub.huntingunion.naziv}</Text>
		<Text style={styles.textmedium}>{huntingclub.naziv} {huntingclub.mjesto}</Text>
		<Text style={styles.textmedium}>{datum}</Text>
	
	<Svg style={styles.text} width="800" height="100" viewBox="0 0 800 100">
		<Text style={styles.textmediumlarge} x="170" y="80">Pregled odlikovanja</Text>
	</Svg>	
	
	<View wrap style={styles.body}> 
      <View style={styles.table}> 
        <View wrap={false} style={styles.tableRow}> 
		  <View style={styles.tableColVeryShort}> 
            <Text style={styles.tableCell}>Broj</Text> 
          </View> 
          <View style={styles.tableColLong}> 
            <Text style={styles.tableCell}>Ime i prezime</Text> 
          </View> 
          <View style={styles.tableColLong}> 
            <Text style={styles.tableCell}>Lovačko društvo</Text> 
          </View> 
          <View style={styles.tableColLong}> 
            <Text style={styles.tableCell}>Odlikovanje</Text> 
          </View> 
	      <View style={styles.tableColShort}> 
            <Text style={styles.tableCell}>Datum</Text> 
          </View> 
        </View>
		
    {filteredTrophies.map((trophy, index) => (
	
	true && ( 
		<View key = {trophy.id} wrap={false} style={styles.tableRow}> 
          <View wrap={false} style={styles.tableColVeryShort}> 
            <Text style={styles.tableCell}>{index + 1}.</Text> 
          </View> 
          <View wrap={false} style={styles.tableColLong}> 
            <Text style={styles.tableCell}>{trophy.hunter.ime} {trophy.hunter.prezime}</Text> 
          </View> 
          <View wrap={false} style={styles.tableColLong}> 
            <Text style={styles.tableCell}>{trophy.hunter.huntingclub.naziv}</Text> 
          </View> 
          <View wrap={false} style={styles.tableColLong}> 
            <Text style={styles.tableCell}>{trophy.awardtype.naziv}</Text> 
          </View> 
          <View wrap={false} style={styles.tableColShort}> 
            <Text style={styles.tableCell}>{trophy.datum}</Text> 
          </View> 
        </View> 
	  )
    ))}
      </View>
	</View>
	  
    <View size="A4" style={styles.officer}>	 
	<Text size="A4" style={styles.officertext} >{huntingclub.sekretar}</Text>
	<Text size="A4" style={styles.officertext} >______________________________</Text>
	<Text size="A4" style={styles.officertext} >(Sekretar udruženja)</Text>
	</View>	
	
	<Text size="A4" style={styles.mp}>
		M.P.
	</Text>

    <Text
        style={styles.pageNumber}
        render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
        fixed
    />
    </Page>
	</Document>
  )

  return (
    <>
      <Helmet>
        <title>  Savez lovačkih organizacija u BiH </title>
      </Helmet>
	  
	  <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Brisanje odlikovanja 
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Da li ste sigurni?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleNo}>Ne</Button>
          <Button onClick={handleYes} autoFocus>Da</Button>
        </DialogActions>
      </Dialog>

      <Container maxWidth="xl">
	  	<div>
		<Button onClick={() => setShowBuildingCreate(!showbuildingcreate)}>Add</Button>
			{showbuildingcreate && (
			<>
			<HuntersIzborForAwardAll handler = {handleRefresh} className = "child"/>
			</>
			)}		
	    </div>
		
		<Typography variant="subtitle2" noWrap>
			Pregled dodjeljenih odlikovanja
		</Typography>
		
        <Card>
          <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
				  color='#002884'
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={buildings.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredTrophies.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { id, datum, opis, napomena, hunter, awardtype } = row; 
					
                    const selectedUser = selected.indexOf(id) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={selectedUser}>
                        <TableCell component="th" scope="row" >
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Avatar alt={awardtype.photo} src={awardtype.photo} sx={{ width: 50, height: 50 }} variant="rounded"/>
                          </Stack>
                        </TableCell>
						
						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{awardtype.naziv}
						</Typography>
						</TableCell>
						
						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{hunter.ime} {hunter.prezime}
						</Typography>
						</TableCell>
						
		                <TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{hunter.huntingclub.naziv}
						</Typography>
						</TableCell>
						
						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{datum}
						</Typography>
						</TableCell>
						
						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{opis}
						</Typography>
						</TableCell>	

						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{napomena}
						</Typography>
						</TableCell>						

						<TableCell> 
						<Button onClick={(event) => handleClickDelete(event, id)}>Delete</Button>
						</TableCell>
						
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredTrophies.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
				
		<br />
		
		<Button onClick={() => setLoading(!loading)}>Print</Button>
		
		<div>
			{showbuildingreport && <BuildingReport building = {building}/>}		
	    </div>	
		
		
		{loading ? ( 
		<div className = "child">	 
		<PDFViewer className = "child">
		<BuildingsReportAll />
		</PDFViewer>
		</div>	
		)
		:
		(
		<>
		</>
		)
		}
	
      </Container>
	  
    </>
  );
}
